import GetPaidRuntime from "./GetPaidRuntime";

export default function GetPaidPage() {
  return <GetPaidRuntime />;
}
